const PropTypes = require('prop-types');
const React = require('react');
const Photo = require('./photo.js');
const classNames = require('classnames');

class Uploader extends React.Component {
  static get defaultProps() {
    return {
      dropFilesDisabled: false,
      dropZoneSelector: 'body',
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      isUploading: false,
      isDragging: false,
      progress: 0,
    };
  }

  componentDidMount() {
    const uploadOptions = this.props.uploadOptions;
    const options = {
      url: uploadOptions.html.data.url,
      formData: uploadOptions.html.data.form_data,
      dataType: 'json',
      paramName: 'file',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      sequentialUploads: true,
      acceptFileTypes: /^image\/jpeg|image\/png$/i,
      done: (e, data) => this.handleUploadSuccess(data.result),
      always: () => this.handleUploadDone(),
      send: () => this.handleUploadStart(),
      progressall: (e, data) => this.handleProgress(data),
    };

    if (this.props.dropFilesDisabled) {
      options.dropZone = null;
    } else {
      options.dropZone = $(this.props.dropZoneSelector);
      options.dragover = () => this.handleDragOver();
      this.bindDragLeave();
    }

    $(this.refs.input).fileupload(options);
  }

  bindDragLeave() {
    $(document).on('dragleave', this.props.dropZoneSelector, () => {
      // Set isDragging to false. If it is still false in 10ms, then we have actually
      // left the window. Otherwise this may be called when dragging into other elements
      // on the page, in which case isDragging will have been set back to true.
      this.setState({ isDragging: false });
      setTimeout(() => {
        if (!this.state.isDragging) {
          this.handleDragLeave();
        }
      }, 10);
    });
  }

  handleUploadStart() {
    this.setState({
      isUploading: true,
      progress: 0,
    });
    this.handleDragLeave();
  }

  handleUploadSuccess(result) {
    this.props.onFileAdded(new Photo(result));
    this.handleUploadDone();
  }

  handleUploadDone() {
    this.setState({ isUploading: false });
  }

  handleProgress(data) {
    const progress = parseInt(data.loaded / data.total * 100, 10);
    this.setState({ progress });
  }

  handleDragOver() {
    this.setState({ isDragging: true });
    this.props.onDragStart();
  }

  handleDragLeave() {
    this.setState({ isDragging: false });
    this.props.onDragEnd();
  }

  renderLabel() {
    if (this.state.isUploading) {
      return I18n.t('js.listingForm.photos.uploader.progress', { percent: this.state.progress });
    }

    return I18n.t('js.listingForm.photos.uploader.uploadPhotos');
  }

  render() {
    const className = classNames(
      'img-uploader__thumb',
      'img-uploader__thumb--add-photo',
      { 'img-uploader__thumb--add-photo--active': !this.state.isUploading }
    );
    return (
      <div className={className}>
        <div className="img-uploader__thumb__message">
          <label>{this.renderLabel()}</label>
        </div>
        <input
          ref="input"
          type="file"
          accept="image/jpeg,image/png"
          multiple={this.props.uploadOptions.html.multiple}
        />
      </div>
    );
  }
}

Uploader.propTypes = {
  uploadOptions: PropTypes.object.isRequired,
  onFileAdded: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  dropFilesDisabled: PropTypes.bool,
  dropZoneSelector: PropTypes.string,
};

module.exports = Uploader;



// WEBPACK FOOTER //
// ./javascripts/components/photos/uploader.jsx